import React from "react";
import { graphql } from "gatsby";
import Img from "gatsby-image";
import Moment from "react-moment";
import Layout from "../components/layout";
import Markdown from "react-markdown";
import YunJia from "../components/yunJia"
import LianXi from "../components/lianXi"

export const query = graphql`
  query ArticleQuery($slug: String!) {
    strapiArticle(slug: { eq: $slug }, status: { eq: "published" }) {
      strapiId
      title
      description
      content
      publishedAt
      image {
        publicURL
        childImageSharp {
          fixed {
            src
            ...GatsbyImageSharpFixed
          }
        }
      }
      author {
        name
        picture {
          childImageSharp {
            fixed(width: 30, height: 30) {
              src
              ...GatsbyImageSharpFixed
            }
          }
        }
      }
    }
  }
`;

const Article = ({ data }) => {
  const article = data.strapiArticle;
  const seo = {
    metaTitle: article.title,
    metaDescription: article.description,
    shareImage: article.image,
    article: true,
  };

  return (
<Layout>
    <table width="970" border="0" cellSpacing="0" cellPadding="0" align="center" bgcolor="#FFFFFF">
    <tbody><tr>
      <td width="265" valign="top">
      <table width="263" border="0" cellSpacing="0" cellPadding="0" align="center">
        <tbody><tr>
          <td>&nbsp;</td>
        </tr>
              <tr>
          <td width="263" height="38" background="/images/left_bj1.gif" style={{ paddingLeft: '25px' }}>&nbsp;<span className="STYLE3">新闻中心</span></td>
    </tr>
        <tr>
          <td><table width="100%" border="0" cellSpacing="0" cellPadding="0">
            <tbody><tr>
              <td width="1" bgcolor="#e5e5e9"></td>
              <td width="261">
            <table width="95%" border="0" cellPadding="0" cellSpacing="0" align="center">
    
    <tbody>
    <tr><td height="25">&nbsp;<img src="/images/1.gif" width="9" height="10" />&nbsp;<a href="/category/news">行业新闻</a></td></tr>
    <tr><td height="25">&nbsp;<img src="/images/1.gif" width="9" height="10" />&nbsp;<a href="/price">最新运价</a></td></tr>
    </tbody>
    </table>
    </td>
    <td width="1"></td>
    </tr>
    </tbody></table></td>
        </tr>
        <tr>
          <td width="263" height="1" bgcolor="#e5e5e9"></td>
        </tr>
              <tr>
          <td>&nbsp;</td>
        </tr>
      </tbody>
      </table>
      {/* 运价 */}
      <YunJia />
       {/* end运价 */}
      <table style={{marginTop: '10px'}} cellSpacing="0" cellPadding="0" width="214" border="0" align="center" background="/images/6.gif" height="200">
                <tbody>
                <tr>
                  <td height="20"></td>
                </tr>
                <tr>
                  <td>
                    <table cellSpacing="0" cellPadding="8" width="210" align="center" border="0">
                      <tbody>
                      <tr><td align="left"><LianXi /></td></tr> 
                      </tbody>
                          </table>
                          </td>
                          </tr>
                          </tbody>
                          </table>
    </td>
      {/* 右栏 */}
      <td valign="top">
      <table width="95%" border="0" cellSpacing="0" cellPadding="0" align="center">
      <tbody><tr>
        <td>&nbsp;</td>
      </tr>
      <tr>
        <td width="669" height="37" background="/images/index_bj1.gif" style={{paddingLeft:'25px'}}>&nbsp;<span className="STYLE3">{article.title}</span></td>
      </tr>
      <tr>
      <td>
      <table width="100%" border="0" cellSpacing="0" cellPadding="0">
  <tbody><tr>
    <td width="1" bgcolor="#e5e5e9"></td>
    <td width="667"></td>
    <td width="1" bgcolor="#e5e5e9"></td>
  </tr>
</tbody></table>
</td>
      </tr>
            <tr>
        <td width="669" height="1">
        <table width="90%" border="0" cellspacing="0" cellpadding="0" align="center">
                        <tbody><tr>
                          <td height="35" align="center">{article.title}!</td>
                        </tr>
                        <tr>
                          <td height="1" colspan="2" background="/images/naBialym.gif"><img height="1" src="/images/1x1_pix.gif" width="10" /></td>
                        </tr>
                        <tr>
                          <td colspan="2" align="center" height="25" bgcolor="#f8f8f8">录入时间：<Moment format="YYYY-MM-DD">{article.published_at}</Moment></td></tr>
                        <tr>
                          <td colspan="2"><table width="95%" border="0" cellspacing="0" cellpadding="0" align="center">
  <tbody><tr>
    <td><div style={{textAlign:'justify',textJustify:'inter-ideograph',lineHeight: '25px',fontSize: '13px', marginTop: '5px'}}>
    <Markdown source={article.content} escapeHtml={false} />
                            </div></td>
  </tr>
</tbody></table>                          </td></tr>
                        <tr>
                          <td height="1" colspan="2" background="/images/naBialym.gif"><img height="1" src="/images/1x1_pix.gif" width="10" /></td>
                        </tr>
                    </tbody></table>
        </td>
      </tr>
    </tbody>
    </table>     
      </td>
      {/* end 右栏 */}
    </tr>
    </tbody></table>
    </Layout>
  );
};

export default Article;
